import { gql, useQuery } from "@apollo/client";
import {
  // AddIcon,
  // Button,
  // Checkbox,
  // CrossIcon,
  // IconButton,
  // Pane,
  // SideSheet,
  // TextInputField,
  // toaster,
  Spinner,
  Table,
} from "evergreen-ui";
import React from "react";
import { PACKAGE_FRAGMENT } from "src/fragments";
import styled from "styled-components";
// import { useForm } from "react-hook-form";

export const GET_PACKAGES = gql`
  {
    packages(order_by: { weight: asc }) {
      ...PackagePart
    }
  }
  ${PACKAGE_FRAGMENT}
`;

// const NEW_PACKAGE = gql`
//   mutation newPackage($object: packages_insert_input!) {
//     insert_packages_one(object: $object) {
//       ...PackagePart
//     }
//   }
//   ${PACKAGE_FRAGMENT}
// `;

const Title = styled.h1`
  ${(props) => props.theme.title}
`;

const Packages = () => {
  const { data, loading, error } = useQuery(GET_PACKAGES);
  // const [newPackage, { loading: insertLoading }] = useMutation(NEW_PACKAGE);
  // const { handleSubmit, register, errors, getValues } = useForm();
  // const [newOrderPayCompany, setNewOrderPayCompany] = useState(false);

  // const [showNew, setShowNew] = useState(false);

  // const toggleSideSheet = () => {
  //   setShowNew(!showNew);
  // };

  // const insertPackage = () => {
  //   if (!insertLoading) {
  //     newPackage({
  //       variables: {
  //         object: { ...getValues(), country: 1 },
  //       },
  //     })
  //       .then(() => {
  //         toaster.success("Package added.");
  //         refetch();
  //       })
  //       .catch((e) => {
  //         toaster.danger(e.message);
  //       });
  //   }
  // };
  return (
    <div className=" admin-page-container pb-96">
      <div className=" admin-page-header">
        <Title>Packages</Title>
        <div className=" admin-buttons-group">
          {/* <Button
            appearance="minimal"
            iconBefore={AddIcon}
            onClick={toggleSideSheet}
          >
            New Package
          </Button> */}
        </div>
      </div>
      <Table>
        <Table.Head>
          <Table.TextHeaderCell>NAME</Table.TextHeaderCell>
          <Table.TextHeaderCell>QUANTITY</Table.TextHeaderCell>
          <Table.TextHeaderCell>FREE</Table.TextHeaderCell>
          <Table.TextHeaderCell>STATUS</Table.TextHeaderCell>
          <Table.TextHeaderCell>PAY TO COMPANY</Table.TextHeaderCell>
          <Table.TextHeaderCell>COUNTRY</Table.TextHeaderCell>
        </Table.Head>
        {loading && (
          <div className=" loading-container">
            <Spinner />
          </div>
        )}
        {error && error.message}
        {data?.packages?.map((pac, index) => (
          <Table.Row key={index}>
            <Table.TextCell>
              {pac.name} | {pac.chinese_name}
            </Table.TextCell>
            <Table.TextCell>{pac.min}</Table.TextCell>
            <Table.TextCell>{pac.system_offer}</Table.TextCell>
            <Table.TextCell>{pac.status}</Table.TextCell>
            <Table.TextCell>{pac.pay_company ? "Yes" : "No"}</Table.TextCell>
            <Table.TextCell>{pac.package_country.name}</Table.TextCell>
          </Table.Row>
        ))}
      </Table>
      {/* <SideSheet
        preventBodyScrolling
        containerProps={{
          display: "flex",
          flex: "1",
          flexDirection: "column",
          maxWidth: "100vw",
        }}
        isShown={showNew}
      >
        <Pane
          position="sticky"
          top="0"
          zIndex={1}
          flexShrink={0}
          elevation={0}
          background="white"
        >
          <div className=" p-4 flex flex-row items-center justify-between">
            <h1 className=" font-semibold">New Package</h1>
            <IconButton icon={CrossIcon} onClick={toggleSideSheet} />
          </div>
        </Pane>
        <div className=" p-4 flex w-full h-full">
          <form
            onSubmit={handleSubmit(insertPackage)}
            className=" sidesheet-tab-sections"
          >
            <TextInputField
              name="name"
              label="Name"
              validationMessage={errors?.name?.message}
              ref={register({ required: "Please enter a name." })}
            />
            <TextInputField
              name="chinese_name"
              label="Chinese Name"
              validationMessage={errors?.chinese_name?.message}
              ref={register({ required: "Please enter a name." })}
            />
            <TextInputField
              name="min"
              label="Quantity"
              validationMessage={
                errors?.min?.message ||
                (errors?.min?.type === "min" && "Quantity must be 0 or above")
              }
              ref={register({ min: 0, required: "Please enter a number." })}
            />
            <TextInputField
              name="system_offer"
              label="Free (Won't deduct upline stock)"
              validationMessage={
                errors?.system_offer?.message ||
                (errors?.system_offer?.type === "min" &&
                  "Free must be 0 or above")
              }
              ref={register({ min: 0, required: "Please enter a number." })}
            />
            <TextInputField
              name="unit_price"
              label="Unit Price"
              validationMessage={
                errors?.unit_price?.message ||
                (errors?.unit_price?.type === "min" &&
                  "Unit Price must be 0 or above")
              }
              ref={register({ min: 0, required: "Please enter a number." })}
            />
            <Checkbox
              label="Pay to company?"
              name="pay_company"
              checked={newOrderPayCompany}
              onChange={(e) => {
                setNewOrderPayCompany(e.target.checked);
              }}
              ref={register()}
            />
            <Button onClick={handleSubmit(insertPackage)}>Add Package</Button>
          </form>
        </div>
      </SideSheet> */}
    </div>
  );
};

export default Packages;
